export const LOYALTY_TABS = Object.freeze({
  LOCATIONS: 'locations',
  BUSINESS: 'business-profile'
});
